// Package tiers (BE src/config/mcpTiers.js). FREE is automatic for every clinic.
export const MCP_TIER_LABELS = {
  FREE: "ฟรี",
  STARTER: "STARTER",
  PRO: "PRO",
};

export const mcpTierLabel = tier => MCP_TIER_LABELS[tier] || tier || "-";

// Audited MCP tools (tool 0 list_branches_and_doctors is never audited) — spec §6.2.
export const MCP_TOOL_LABELS = {
  get_clinic_overview: "ภาพรวมคลินิก",
  get_revenue_breakdown: "แยกรายได้",
  list_receipts: "รายการใบเสร็จ",
  get_receipt: "รายละเอียดใบเสร็จ",
  list_receipt_lines: "รายการในใบเสร็จ",
  get_doctor_payout: "ค่าตอบแทนแพทย์",
  list_outstanding_balances: "ยอดค้างชำระ / มัดจำ / จัดฟัน",
  list_appointments: "รายการนัดหมาย",
  get_appointment_stats: "สถิตินัดหมาย",
  get_doctor_schedule: "ตารางแพทย์",
  find_patients: "ค้นหาคนไข้",
  get_patient: "ข้อมูลคนไข้",
  get_patient_segments: "กลุ่มคนไข้",
  get_acquisition_report: "ที่มาคนไข้ใหม่",
  get_growth_opportunities: "โอกาสเพิ่มรายได้",
};

export const MCP_STATUS_LABELS = {
  OK: { text: "สำเร็จ", variant: "success" },
  ERROR: { text: "ผิดพลาด", variant: "danger" },
  DENIED: { text: "ไม่มีสิทธิ์", variant: "warning" },
  QUOTA: { text: "เกินโควตา", variant: "warning" },
  RATE_LIMITED: { text: "เรียกถี่เกินไป", variant: "secondary" },
};
